/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import useId from '@mui/utils/useId';
import { StyledResultsPerPage } from './tableResultsPerPageStyles';
import { ResultsPerPageSelect } from './resultsPerPageSelect/resultsPerPageSelect';
export var EmbersTableResultsPerPage = function EmbersTableResultsPerPage(props) {
  var onResultsPerPageChange = props.onResultsPerPageChange,
    resultsPerPage = props.resultsPerPage,
    resultsPerPageOptions = props.resultsPerPageOptions,
    pageCount = props.pageCount,
    mixpanelProps = props.mixpanelProps;
  var intl = useIntl();
  var id = useId();
  var options = resultsPerPageOptions !== null && resultsPerPageOptions !== void 0 && resultsPerPageOptions.length ? resultsPerPageOptions : [25, 50, 100];
  var currentPerPage = resultsPerPage || options[0];

  // hide ResultsPerPage when total <= minimum number of resultsPerPage
  if (pageCount === 1 && currentPerPage === options[0]) return null;
  return /*#__PURE__*/React.createElement(StyledResultsPerPage, {
    className: "EmbersTable-ResultsPerPage-root"
  }, /*#__PURE__*/React.createElement("span", {
    className: "EmbersTable-ResultsPerPage-title",
    id: "".concat(id, "-results-per-page-label")
  }, intl.formatMessage({
    id: 'embers.table.bottomControls.resultsPerPage',
    defaultMessage: 'Results per page'
  })), /*#__PURE__*/React.createElement(ResultsPerPageSelect, {
    options: options,
    value: currentPerPage,
    onChange: function onChange(value) {
      var _mixpanelProps$tracke, _mixpanelProps$tracke2;
      mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke = (_mixpanelProps$tracke2 = mixpanelProps.tracker).changePageSize) === null || _mixpanelProps$tracke === void 0 || _mixpanelProps$tracke.call(_mixpanelProps$tracke2, mixpanelProps === null || mixpanelProps === void 0 ? void 0 : mixpanelProps.tableName, value);
      onResultsPerPageChange && onResultsPerPageChange(value);
    },
    id: "".concat(id, "-results-per-page-select"),
    labelId: "".concat(id, "-results-per-page-label")
  }));
};